var map = {
	"./AppAboutScreen.png": "44e3",
	"./AppArmSensor.png": "bd1f",
	"./AppArmSensorGarminVivosmart5.png": "fb88",
	"./AppCertScreen.png": "ba88",
	"./AppDashboardScreen.png": "b936",
	"./AppEarSensor.png": "bf59",
	"./AppEventScreen.png": "9aaf",
	"./AppLoginScreen.png": "66b8",
	"./AppMeasurementPlanScreen.png": "a1ef",
	"./AppMeasurementsScreen.png": "f29d",
	"./AppQRScreen.png": "f3f9",
	"./AppQuestionnaireScreen1.png": "edff",
	"./AppQuestionnaireScreen2.png": "dadc",
	"./AppQuestionnaireScreen3.png": "9c9c",
	"./AppSensorsScreen.png": "0173",
	"./AppSensorsScreen1.png": "1ac5",
	"./AppSensorsScreen2.png": "e36b",
	"./CaseCreation.png": "bf75",
	"./CaseEvaluation.png": "0ea6",
	"./ClientAuthScreen.png": "0a78",
	"./ClientCaseCreationScreen1.png": "c1da",
	"./ClientCaseCreationScreen2.png": "98a4",
	"./ClientPatientCreationScreen.png": "ff35",
	"./ClientProfileScreen.png": "c6c0",
	"./ClientQueryScreen.png": "71da",
	"./ClientQuestionnaireCreationScreen.png": "27bf",
	"./ClientVisScreen1.png": "3381",
	"./ClientVisScreen2.png": "4d33",
	"./ClientVisScreen3.png": "b0a7",
	"./ClientVisScreen4.png": "4c20",
	"./ClientVisScreen5.png": "6f97",
	"./ClientVisScreen6.png": "7d53",
	"./Logo.png": "bca0",
	"./LogoMinisterium.png": "dc20",
	"./Registration.png": "6d38",
	"./Registration2.png": "9c65",
	"./english.svg": "3b3b",
	"./german.svg": "8887"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";